export const PHONE = "(615) 766-3977";
export const PHONE_TEL = "tel:+16157663977";
export const EMAIL = "hflandscapesolutions@gmail.com";

export const NAV = [
  { id: "services", label: "Services" },
  { id: "work", label: "Our Work" },
  { id: "reviews", label: "Reviews" },
  { id: "areas", label: "Service Areas" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Grounds Maintenance",
    text: "Ground maintenance tailored to your specific needs. Residential and commercial properties kept looking great year-round — whatever maintenance you need, we have you covered.",
    tags: ["Residential", "Commercial", "Year-round"],
    img: "/img/p3.jpg",
  },
  {
    no: "02",
    title: "Retaining Walls & Gravel Driveways",
    text: "Gravel driveways and walkways of all sizes — from a simple refresh to full site prep and gravel surface installation. Retaining walls big and small (up to certain heights).",
    tags: ["Driveways", "Walkways", "Retaining walls"],
    img: "/img/p4.jpg",
  },
  {
    no: "03",
    title: "Landscaping, A to Z",
    text: "Anything landscaping, A–Z. We specialize in every aspect of landscaping, giving you an outdoor space that is both beautiful and functional.",
    tags: ["Planting", "Beds & mulch", "Design"],
    img: "/img/p5.jpg",
  },
];

export const GALLERY = [
  { src: "/img/p6.jpg", cls: "col-span-2 row-span-2" },
  { src: "/img/p4.jpg", cls: "col-span-2" },
  { src: "/img/p3.jpg", cls: "" },
  { src: "/img/p7.jpg", cls: "" },
  { src: "/img/n83.jpg", cls: "row-span-2" },
  { src: "/img/p5.jpg", cls: "col-span-2" },
  { src: "/img/p9.jpg", cls: "row-span-2" },
  { src: "/img/n81.jpg", cls: "" },
  { src: "/img/p11.jpg", cls: "" },
  { src: "/img/n82.jpg", cls: "col-span-2" },
  { cta: true, cls: "col-span-2" },
];

export const REVIEWS = [
  { name: "Chuck M.", date: "Apr 2025", source: "Facebook", text: "Hunter was great to work with. The numerous trees and bushes we purchased and planted by Hunter are thriving! Despite having planted several weeks ago and immediately went into this unusual continuous Spring drought, by following Hunter's instructions of regular watering and the soil additions and conditioning he made are proving fruitful." },
  { name: "April W.", date: "Jun 11", source: "Yelp", text: "Hunter is an absolute delight to work with. He is very knowledgeable about all of the landscape ins and outs. Hunter is extremely good with communication from the beginning to the end of the process. Highly recommend Hunter and his crew." },
  { name: "Teresa S.", date: "Jun 2025", source: "Facebook", text: "Hunter and crew did a weed spray for our entire 5 acre fence line, inside and out. Highly Recommend! Responsible, professional, respectful, and affordable. Great work, thanks!!" },
  { name: "Tina H.", date: "Jun 2025", source: "Facebook", text: "Hunter has worked for me 2 years now and I think he's a keeper. He's so sweet and hardworking! He always keeps in touch and he's very reliable. Thank you so much Hunter!" },
  { name: "Alicia V.", date: "Apr 2025", source: "Facebook", text: "Hunter and Isaac from HF Landscaping did a great job helping me give my yard a face-lift. They planted 30 flowering ivies, pulled out 4 huge dead bushes, and helped me critter-proof my fence. They did it all in about 4 hours! Friendly, professional, good communication — highly recommend these guys!" },
  { name: "E. J. Johnson", date: "Mar 2025", source: "Facebook", text: "They did cleanup on my property. Cut low branches on trees, removed leaves and other trash. They did an excellent job. Site was totally cleaned as agreed. All cleanup was hauled away. Fair price. Highly recommend them. I give a Five Star rating." },
  { name: "Kristin M.", date: "Feb 2025", source: "Facebook", text: "Hunter and crew are awesome! All the guys are very respectful and prompt! They did a great job! 10 out of 10 recommend!" },
];

export const WHY = [
  { title: "Quality Service Guaranteed", icon: "BadgeCheck" },
  { title: "Professional & Uniformed", icon: "Shirt" },
  { title: "Locally Owned & Operated", icon: "Home" },
  { title: "Safe & Reliable Equipment", icon: "Tractor" },
  { title: "Most Payment Methods Accepted", icon: "CreditCard" },
  { title: "Fully Licensed & Insured", icon: "ShieldCheck" },
];

export const AREAS = [
  "Pleasant View", "Ashland City", "Joelton", "Coopertown", "Springfield", "Greenbrier", "Pegram",
  "Goodlettsville", "Belle Meade", "Hendersonville", "Charlotte", "Dickson", "Brentwood", "Clarksville", "Adams",
];

export const SERVICE_OPTIONS = [
  "Grounds Maintenance", "Retaining Walls", "Gravel Driveways & Walkways",
  "Landscaping & Planting", "Cleanup & Weed Control", "Something Else",
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
